/* Merme Product Detail — gallery, tabs, variant, buy-now, wishlist */
(function () {
  function initSection(root) {
    if (root.dataset.mpdReady) return;
    root.dataset.mpdReady = '1';

    /* ---- Gallery + full-screen lightbox (matches merme.in zoom view) ---- */
    var gallery = root.querySelector('[data-mpd-gallery]');
    var lightbox = root.querySelector('[data-mpd-lightbox]');
    if (gallery) {
      var slides = [].slice.call(gallery.querySelectorAll('[data-mpd-slide]'));
      var thumbs = [].slice.call(gallery.querySelectorAll('[data-mpd-thumb]'));
      var lbSlides = lightbox ? [].slice.call(lightbox.querySelectorAll('[data-mpd-lb-slide]')) : [];
      var lbThumbs = lightbox ? [].slice.call(lightbox.querySelectorAll('[data-mpd-lb-thumb]')) : [];
      var lbCur = lightbox ? lightbox.querySelector('[data-mpd-lb-cur]') : null;
      var count = slides.length;
      var idx = 0;
      var show = function (n) {
        if (!count) return;
        idx = (n + count) % count;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        lbSlides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        lbThumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        if (lbCur) lbCur.textContent = idx + 1;
        var at = thumbs[idx]; if (at && at.scrollIntoView) at.scrollIntoView({ inline: 'nearest', block: 'nearest' });
        var lat = lbThumbs[idx]; if (lat && lat.scrollIntoView) lat.scrollIntoView({ inline: 'nearest', block: 'nearest' });
      };
      var prev = gallery.querySelector('[data-mpd-prev]');
      var next = gallery.querySelector('[data-mpd-next]');
      if (prev) prev.addEventListener('click', function () { show(idx - 1); });
      if (next) next.addEventListener('click', function () { show(idx + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-mpd-thumb'), 10)); });
      });

      /* lightbox open/close + controls */
      if (lightbox) {
        var openLb = function () { show(idx); lightbox.hidden = false; lightbox.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
        var closeLb = function () { lightbox.hidden = true; lightbox.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
        slides.forEach(function (s) { s.addEventListener('click', openLb); });
        [].forEach.call(lightbox.querySelectorAll('[data-mpd-lb-close]'), function (b) { b.addEventListener('click', closeLb); });
        var lbPrev = lightbox.querySelector('[data-mpd-lb-prev]');
        var lbNext = lightbox.querySelector('[data-mpd-lb-next]');
        if (lbPrev) lbPrev.addEventListener('click', function () { show(idx - 1); });
        if (lbNext) lbNext.addEventListener('click', function () { show(idx + 1); });
        lbThumbs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-mpd-lb-thumb'), 10)); }); });
        document.addEventListener('keydown', function (e) {
          if (lightbox.hidden) return;
          if (e.key === 'Escape') closeLb();
          else if (e.key === 'ArrowLeft') show(idx - 1);
          else if (e.key === 'ArrowRight') show(idx + 1);
        });
        /* swipe to navigate on touch */
        var sx = null;
        lightbox.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        lightbox.addEventListener('touchend', function (e) {
          if (sx == null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
          if (Math.abs(dx) > 40 && count > 1) show(idx + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }
    }

    /* ---- Tabs ---- */
    var tabsWrap = root.querySelector('[data-mpd-tabs]');
    if (tabsWrap) {
      var tabs = [].slice.call(tabsWrap.querySelectorAll('[data-mpd-tab]'));
      var panels = [].slice.call(tabsWrap.querySelectorAll('[data-mpd-panel]'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-mpd-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-mpd-panel') === key); });
        });
      });
    }

    /* ---- Option pickers (one per option, Dawn-style) → resolve variant,
            update hidden id + price + sku + availability ---- */
    var form = root.querySelector('.mpd-form');
    var priceVal = root.querySelector('[data-mpd-price-val]');
    var skuEl = root.querySelector('[data-mpd-sku]');
    var idInput = root.querySelector('[data-mpd-variant-id]');
    var optInputs = [].slice.call(root.querySelectorAll('[data-mpd-option]'));
    var variantsData = [];
    var variantsEl = root.querySelector('[data-mpd-variants]');
    if (variantsEl) { try { variantsData = JSON.parse(variantsEl.textContent); } catch (e) {} }

    function selectedOptions() {
      var opts = [];
      optInputs.forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-mpd-option'), 10) - 1;
        if (el.tagName === 'SELECT') opts[pos] = el.value;
        else if (el.checked) opts[pos] = el.value;
      });
      return opts;
    }
    function findVariant(opts) {
      for (var i = 0; i < variantsData.length; i++) {
        var vd = variantsData[i];
        var match = true;
        for (var j = 0; j < vd.options.length; j++) {
          if (vd.options[j] !== opts[j]) { match = false; break; }
        }
        if (match) return vd;
      }
      return null;
    }
    function resolveVariant() { return findVariant(selectedOptions()); }

    /* Grey out option values that — combined with the other pickers' current
       selections — resolve to a missing or sold-out variant. Values stay
       clickable so the shopper can always switch combinations. */
    function updateOptionStates() {
      var sel = selectedOptions();
      optInputs.forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-mpd-option'), 10) - 1;
        if (el.tagName === 'SELECT') {
          [].forEach.call(el.options, function (opt) {
            var cand = sel.slice(); cand[pos] = opt.value;
            var vd = findVariant(cand);
            var ok = !!(vd && vd.available);
            if (!opt.getAttribute('data-label')) opt.setAttribute('data-label', opt.textContent);
            opt.textContent = ok ? opt.getAttribute('data-label') : opt.getAttribute('data-label') + ' — Sold out';
            opt.classList.toggle('is-unavailable', !ok);
          });
        } else {
          var cand = sel.slice(); cand[pos] = el.value;
          var vd = findVariant(cand);
          var pill = root.querySelector('label[for="' + el.id + '"]');
          if (pill) pill.classList.toggle('is-unavailable', !(vd && vd.available));
        }
      });
    }
    function applyVariant() {
      var vd = resolveVariant();
      var ok = !!(vd && vd.available);
      if (vd && idInput) idInput.value = vd.id;
      if (vd && priceVal) priceVal.textContent = vd.price;
      var compareEl = root.querySelector('.mpd-compare');
      if (compareEl) {
        if (vd && vd.compare_at_price) { compareEl.textContent = vd.compare_at_price; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (skuEl) skuEl.textContent = (vd && vd.sku) ? 'SKU: ' + vd.sku : '';
      var add = root.querySelector('[data-mpd-add]');
      if (add) {
        add.disabled = !ok;
        add.textContent = ok ? (add.getAttribute('data-orig-label') || 'Add to cart') : (vd ? 'Sold out' : 'Unavailable');
      }
      var buy = root.querySelector('[data-merme-buy-now]');
      if (buy) buy.disabled = !ok;
      updateOptionStates();
      refreshInCart();
    }
    optInputs.forEach(function (el) { el.addEventListener('change', applyVariant); });
    if (optInputs.length && variantsData.length) updateOptionStates();

    /* ---- Share block: native share sheet, else copy link ---- */
    var shareBtn = root.querySelector('[data-mpd-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.share) { navigator.share({ title: document.title, url: url }).catch(function () {}); return; }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            var l = shareBtn.querySelector('[data-mpd-share-label]');
            if (!l) return;
            var orig = l.textContent;
            l.textContent = 'Link copied';
            setTimeout(function () { l.textContent = orig; }, 1600);
          }).catch(function () {});
        }
      });
    }

    /* ---- Pop-up blocks (size chart etc.) ---- */
    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-mpd-popup-open]');
      if (opener) {
        var pop = root.querySelector('[data-mpd-popup="' + opener.getAttribute('data-mpd-popup-open') + '"]');
        if (pop) { pop.hidden = false; document.documentElement.style.overflow = 'hidden'; }
        return;
      }
      if (e.target.closest('[data-mpd-popup-close]')) {
        var openPop = e.target.closest('[data-mpd-popup]');
        if (openPop) { openPop.hidden = true; document.documentElement.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openPop = root.querySelector('[data-mpd-popup]:not([hidden])');
      if (openPop) { openPop.hidden = true; document.documentElement.style.overflow = ''; }
    });

    function selectedVariantId() {
      if (idInput) return idInput.value;
      var hidden = form && form.querySelector('input[name="id"]');
      return hidden ? hidden.value : null;
    }
    function quantity() {
      var q = root.querySelector('[data-mpd-qty]');
      return q ? parseInt(q.value, 10) || 1 : 1;
    }

    /* Add to cart + Buy now are handled globally by merme-cart-add.js
       (the form has [data-merme-add-form]; Buy now has [data-merme-buy-now]).
       Wishlist heart is handled globally by merme-wishlist.js. */

    /* ---- In-cart stepper: when this variant is in the cart, replace Add with a − qty + ---- */
    var addBtn = root.querySelector('[data-mpd-add]');
    var inCart = root.querySelector('[data-mpd-incart]');
    var qtyEl = root.querySelector('[data-mpd-cart-qty]');
    var lineKey = null;

    /* Selected line item properties (personalization pills). null = no
       personalization UI on the page; {} = pills present but none picked. */
    function persoProps() {
      var props = null;
      [].forEach.call(root.querySelectorAll('[data-mpd-perso] input[type="radio"]'), function (r) {
        props = props || {};
        if (r.checked) props[r.name.replace(/^properties\[(.+)\]$/, '$1')] = r.value;
      });
      return props;
    }
    function propsMatch(item, props) {
      if (!props) return true;
      var ip = item.properties || {};
      var keys = Object.keys(props);
      if (keys.length !== Object.keys(ip).length) return false;
      return keys.every(function (k) { return ip[k] === props[k]; });
    }

    function refreshInCart() {
      if (!inCart || !addBtn) return;
      var vid = String(selectedVariantId() || '');
      var props = persoProps();
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = (cart.items || []).filter(function (i) {
            return (String(i.id) === vid || String(i.variant_id) === vid) && propsMatch(i, props);
          })[0];
          if (item) {
            lineKey = item.key;
            if (qtyEl) qtyEl.textContent = item.quantity;
            addBtn.hidden = true; inCart.hidden = false;
          } else {
            lineKey = null;
            addBtn.hidden = false; inCart.hidden = true;
          }
        }).catch(function () {});
    }

    if (inCart && addBtn) {
      root.querySelectorAll('[data-mpd-cart-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!lineKey) return;
          var delta = parseInt(b.getAttribute('data-mpd-cart-step'), 10);
          var newQty = Math.max(0, (parseInt(qtyEl.textContent, 10) || 1) + delta);
          var d = (window.MermeCart && window.MermeCart.drawer && window.MermeCart.drawer()) || document.querySelector('cart-drawer');
          var body = { id: lineKey, quantity: newQty };
          if (d && d.getSectionsToRender) { body.sections = d.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname; }
          [].forEach.call(root.querySelectorAll('[data-mpd-cart-step]'), function (x) { x.disabled = true; });
          fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (window.MermeCart) { window.MermeCart.silentUpdate(res, d); window.MermeCart.updateHeaderCount(); }
              [].forEach.call(root.querySelectorAll('[data-mpd-cart-step]'), function (x) { x.disabled = false; });
              refreshInCart();
            }).catch(function () { [].forEach.call(root.querySelectorAll('[data-mpd-cart-step]'), function (x) { x.disabled = false; }); });
        });
      });
      [].forEach.call(root.querySelectorAll('[data-mpd-perso] input[type="radio"]'), function (r) {
        r.addEventListener('change', refreshInCart);
      });
      refreshInCart();
      // delay so the green "Added to cart ✓" animation is visible before switching to the stepper
      document.addEventListener('cart:updated', function () { setTimeout(refreshInCart, 1000); });
    }

    /* ---- Notify Me (back-in-stock app) slot ----
       The app embed appends its button (inside <div class="nm-portal">) to the END of the
       cart form, below the buy row, and leaves our "Sold out" box in place. Move the portal
       into the buy row so "Notify me" takes the Add-to-cart slot, and flag the row so the
       CSS can hide the Sold out box / disabled buttons behind it. The portal stays inside
       the form, so the app's own re-render guard keeps working. */
    var addForm = root.querySelector('[data-merme-add-form]');
    var buyRow = root.querySelector('.mpd-buy');
    if (addForm && buyRow) {
      var placeNotify = function () {
        var portal = addForm.querySelector('.nm-portal');
        if (!portal) return false;
        if (portal.parentElement !== buyRow) {
          var soldOut = buyRow.querySelector('.mpd-soldout');
          if (soldOut) soldOut.insertAdjacentElement('beforebegin', portal);
          else buyRow.appendChild(portal);
        }
        buyRow.classList.add('has-notify');
        return true;
      };
      if (!placeNotify() && window.MutationObserver) {
        var notifyWatch = new MutationObserver(function () { if (placeNotify()) notifyWatch.disconnect(); });
        notifyWatch.observe(addForm, { childList: true, subtree: true });
      }
    }
  }

  function init() { [].forEach.call(document.querySelectorAll('[data-mpd]'), initSection); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-mpd]');
    if (el) initSection(el);
  });
})();
